module.exports = __webpack_public_path__ + "IcoMoon-Free.72c742bc4398b2803e5e.ttf";


//////////////////
// WEBPACK FOOTER
// /mnt/disk/stratbox.dev/src/assets/fonts/IcoMoon-Free.ttf
// module id = ../../../../../src/assets/fonts/IcoMoon-Free.ttf
// module chunks = styles